export default __webpack_public_path__ + "static/hans_giesbers_1-20a35b0838f79e88514433d94314ffdf.jpg";